import { render, staticRenderFns } from "./NonCompliantList.vue?vue&type=template&id=1f874e57"
import script from "./NonCompliantList.vue?vue&type=script&lang=js"
export * from "./NonCompliantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports